import { Box, Text } from '@chakra-ui/react';
import React from 'react';

import StepCard from '../StepCard';
import { Step, StepRenderState, resolveStepDescription } from '../utils';
import StepButtonLink from './StepButtonLink';

type StepContentProps = {
  step: Step;
  state: StepRenderState;
  currentStepActions?: { description?: React.ReactNode; cta?: React.ReactNode };
  onFrozenClick?: () => void;
  onPayoffLookup?: () => void;
  isMobile?: boolean;
  hasSharedEmail?: boolean;
};

const StepContent = ({
  step,
  state,
  currentStepActions,
  onFrozenClick,
  onPayoffLookup,
  isMobile = false,
  hasSharedEmail = false,
}: StepContentProps) => {
  const description = resolveStepDescription(step, {
    ...state,
    currentDescription: currentStepActions?.description,
  });

  const currentStepCta =
    state.isCurrent && currentStepActions?.cta != null ? currentStepActions.cta : undefined;

  const ctaInsideRow = currentStepCta && !(isMobile && hasSharedEmail);
  const ctaBelowRow = currentStepCta && isMobile && hasSharedEmail;

  const labelTrailing =
    state.isCurrent && step.timeEstimate ? (
      <Text fontSize={{ base: 'sm', md: 'md' }} color="royalBlue" fontWeight="semibold">
        {step.timeEstimate}
      </Text>
    ) : undefined;

  const belowDescription = (
    <>
      {state.isFrozenOnGathering && onFrozenClick && (
        <StepButtonLink color="red.500" onClick={onFrozenClick}>
          Click to see how to resolve.
        </StepButtonLink>
      )}
      {state.isPayoffFailedStep && onPayoffLookup && (
        <StepButtonLink color="orange.600" onClick={onPayoffLookup}>
          Look Up Your Payoff &rarr;
        </StepButtonLink>
      )}
      {ctaInsideRow && <Box mt={4}>{currentStepCta}</Box>}
    </>
  );

  return (
    <StepCard
      icon={state.icon}
      iconAvatar={step.isAvatarIcon}
      iconProps={{ opacity: state.iconOpacity }}
      label={step.label}
      labelProps={{ color: state.labelColor }}
      isCompleted={state.isCompleted}
      labelTrailing={labelTrailing}
      description={description}
      descriptionProps={{ color: state.descriptionColor }}
      belowDescription={belowDescription}
      footer={ctaBelowRow ? <Box mt={4}>{currentStepCta}</Box> : undefined}
    />
  );
};

export default StepContent;
